import { useTranslation } from "@next-platform/client-common-core";
import useRulebookHudVisibility from "@next-platform/client-common-core/rulebook/hud/useRulebookHudVisibility";
import { type DropDownMenuItem, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useMemo } from "react";

type UseRulebookHudMenuItemOptions = {
  characterId?: string;
  conversationId?: string;
  /** False for guests and group chats. */
  isAvailable: boolean;
};

/**
 * The chat menu's "Hide meters" / "Show meters" item: hides the meter panel for this chat while evaluation continues.
 * It is the way back once the meters are hidden (the sheet that also offers the switch opens from the panel).
 */
export default function useRulebookHudMenuItem({ characterId, conversationId, isAvailable }: UseRulebookHudMenuItemOptions): DropDownMenuItem {
  const { t } = useTranslation();
  const { isHidden, isShown, toggle } = useRulebookHudVisibility({ characterId, conversationId, isAvailable });

  return useMemo<DropDownMenuItem>(
    () => ({
      icon: isHidden ? IconVariants.EYE : IconVariants.EYE_OFF,
      label: isHidden
        ? t("chat:page.header.dropdown.showMeters.title", "Show meters")
        : t("chat:page.header.dropdown.hideMeters.title", "Hide meters"),
      onPress: toggle,
      isHidden: !isShown,
      dataTestId: "chat-rulebook-hud-menu-item",
    }),
    [isHidden, t, toggle, isShown],
  );
}
